// extracted by mini-css-extract-plugin
module.exports = {"AnimateContainer":"AnimateContainer_AnimateContainer__Jpjl6","setImmediate":"AnimateContainer_setImmediate__pwmOg"};